'use client';

import {
  amplitudeSendEvent,
  GTM_NOTSET_STRING,
  getScreenName,
  pushDataLayer,
} from '@musinsa/frontend-utils';
import { Typography } from '@musinsa/mds';
import { SERVICE, useDeviceInfo } from '@musinsa/packages-device-detection';
import { useQuery } from '@tanstack/react-query';
import clsx from 'clsx';
import dynamic from 'next/dynamic';
import Link from 'next/link';
import type { MouseEventHandler } from 'react';
import { pathsMusinsa } from '../../../common';
import { curatorQueries } from '../../../query-factory';

const DynamicRandomImage = dynamic(() => import('./RandomImage').then((mod) => mod.RandomImage), {
  ssr: false,
});

export const MusinsaEventBannerSection = () => {
  const { service } = useDeviceInfo();

  const { data: mypageData } = useQuery(curatorQueries.mypage.data());

  const {
    title,
    subTitle,
    backgroundColor,
    textColor,
    images = [],
  } = mypageData?.eventCollectionBanner ?? {};

  const handleClick: MouseEventHandler<HTMLAnchorElement> = () => {
    if (service === SERVICE.MUSINSA) {
      amplitudeSendEvent({
        action_name: 'click',
        button_name: 'event_banner',
        component_name: 'button',
        event_name: 'click_button',
        from: getScreenName(),
        name: 'event_banner',
        section_name: 'mypage_event_banner',
      });

      pushDataLayer('click_button', {
        brand_id: GTM_NOTSET_STRING,
        button_id: GTM_NOTSET_STRING,
        button_name: `${title} | ${window.location.origin}${pathsMusinsa.events()}`,
        index: GTM_NOTSET_STRING,
        section_index: '7',
        section_name: 'mypage_event_banner',
      });
    }
  };

  // SID-4418: 배너 섹션(container) 배경 = gray-100. 회색 베이스 위에 배너 카드가 분리되어 보이도록.
  return (
    <section className="!py-[12px] !px-[16px] w-full bg-gray-100">
      <Link href={pathsMusinsa.events()} onClick={handleClick}>
        <div
          className="rounded-border-radius-sm overflow-hidden flex items-center w-full"
          style={{
            backgroundColor: backgroundColor ?? undefined,
          }}
        >
          <div
            className="flex flex-col py-[8px]! pr-[4px]! pl-[16px]! w-full gap-y-[2px]!"
            style={{
              color: textColor ?? undefined,
            }}
          >
            <Typography variant="body13pxSemi">{title}</Typography>
            {subTitle && (
              <Typography variant="body13pxReg" className={clsx('text-[#666666]')}>
                {subTitle}
              </Typography>
            )}
          </div>
          <DynamicRandomImage images={images} />
        </div>
      </Link>
    </section>
  );
};
